import React, { Component, Suspense, lazy } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { ProtectedRoute } from "./ProtectedRoute";
import Spinner from "../app/shared/Spinner";
import { EkycInfo } from "./user-pages/EkycInfo";
import { baseURL } from "./service/ApiUrls";
import api from "./service/ApiService";
const Dashboard = lazy(() => import("./dashboard/Dashboard"));
// const MyPackage = lazy(() => import("./dashboard/MyPackage"));
const AdminRegistration = lazy(() =>
  import("./registration/AdminRegistration")
);

const Error404 = lazy(() => import("./user-pages/Error404"));
const Error500 = lazy(() => import("./user-pages/Error500"));

const Login = lazy(() => import("./user-pages/Login"));
const Login2 = lazy(() => import("./user-pages/Login2"));
const RobiLogin = lazy(() => import("./user-pages/RobiLogin"));
const Register = lazy(() => import("./user-pages/Register"));

const BlankPage = lazy(() => import("./user-pages/BlankPage"));
const Unauthorized = lazy(() => import("./user-pages/Unauthorized"));
const NewSign = lazy(() => import("./signing/NewSign"));
const PendingForMe = lazy(() => import("./signing/PendingForMe"));
const PendingForOther = lazy(() => import("./signing/PendingForOther"));
const SigningRequest = lazy(() => import("./signing/SigningRequest"));
const CompletedSign = lazy(() => import("./signing/CompletedSign"));
const ArchiveSign = lazy(() => import("./signing/ArchiveSign"));
const RejectedSign = lazy(() => import("./signing/RejectedSign"));
const StartSign = lazy(() => import("./signing/StartSign"));
const StartSign2 = lazy(() => import("./signing/StartSign2"));
const ViewPdf = lazy(() => import("./signing/ViewPdf"));
const ActiveFiles = lazy(() => import("./signing/ActiveFiles"));
const StatusUpdate = lazy(() => import("./user-pages/StatusUpdate.js"));
const BulkStatusUpdate = lazy(() => import("./signing/BulkStatusUpdate.js"));
const BulkCancelStatus = lazy(() => import("./signing/BulkCancelStatus.js"));
const PendingRequest = lazy(() => import("./user-pages/PendingRequest.js"));
const PreviewDoc = lazy(() => import("./user-pages/PreviewDoc.js"));
const Cancelled = lazy(() => import("./user-pages/Cancelled.js"));
const Successfull = lazy(() => import("./user-pages/Succesfull.js"));
const Failed = lazy(() => import("./user-pages/Failed.js"));
const ManageSignature = lazy(() => import("./signing/ManageSignature"));
const UserList = lazy(() => import("./user-pages/UserList"));
const ChangePassword = lazy(() => import("./user-pages/ChangePassword"));
const ForgetPassword = lazy(() => import("./user-pages/ForgetPassword"));
const ResetPassword = lazy(() => import("./user-pages/ResetPassword"));
const MyProfile = lazy(() => import("./user-pages/MyProfile"));
const PackageList = lazy(() => import("./admin/PackageList"));
const ActivityLog = lazy(() => import("./admin/ActivityLog"));
const Reports = lazy(() => import("./admin/Reports"));
const MyPackage = lazy(() => import("./admin/MyPackage"));

// const PackageManage = lazy(() => import("./admin/PackageManage"));
const PackageManage2 = lazy(() => import("./admin/PackageManage2"));
const CompanyList = lazy(() => import("./admin/CompanyList"));
const PdfPrepare = lazy(() => import("./signing/PdfPrepare"));
const CompanyUserList = lazy(() => import("./admin/CompanyUserList"));
const NewCompany = lazy(() => import("./admin/NewCompany"));
const PackageDistribute = lazy(() => import("./admin/PackageDistribute"));
const NewUser = lazy(() => import("./admin/NewUser"));
const ImageCrop = lazy(() => import("./imagecrop/ImageCrop"));
const DynamicForm = lazy(() => import("./user-pages/DynamicForm"));
const NewSelfSign = lazy(() => import("./signing/NewSelfSign"));
const StartFollow = lazy(() => import("./form/StartFollow"));
const StartMulti = lazy(() => import("./form/StartMulti"));
const StartTempSign = lazy(() => import("./form/StartSign"));
const StoragePlanList = lazy(() =>
  import("./storage-management/StoragePlanList")
);
const NewStoragePlan = lazy(() =>
  import("./storage-management/NewStoragePlan")
);
const StorageManagement = lazy(() =>
  import("./storage-management/StorageManagement")
);
const MyStorage = lazy(() => import("./storage-management/MyStorage"));
const PurchaseHistory = lazy(() =>
  import("./storage-management/PurchaseHistory")
);
const PendingPurchase = lazy(() =>
  import("./storage-management/PendingPurchase")
);
// const StorageShop1 = lazy(() => import("./storage-management/StorageShop1"));
const StorageShop = lazy(() => import("./storage-management/StorageShop"));
const StorageRequest = lazy(() => import("./system-admin/StorageRequest"));

class AppRoutes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPassError: false,
    };
    //this.callOwnProfile();
  }

  componentDidMount = () => {
    const loggedIn = localStorage.getItem("loggedIn");
    const cachedProfile = localStorage.getItem("myProfile");

    if (loggedIn === "true") {
      if (!cachedProfile) {
        this.callOwnProfile();
      } else {
        const parsed = JSON.parse(cachedProfile);
        this.setState({ ownProfile: parsed });
      }
    }
  };
  // componentDidMount = () => {
  //   const loggedIn = localStorage.getItem("loggedIn");
  //   let menu = localStorage.getItem("myProfile");
  //   //console.log("menu ", menu);
  //   if (loggedIn === "true" && (menu === null || menu === undefined)) {
  //     this.callOwnProfile();
  //   } else {
  //     this.setState({ ...JSON.parse(menu) });
  //   }
  //   // this.callOwnProfile();
  // };

  // componentDidUpdate(prevProps) {
  //   //console.log("prev props", prevProps, this.props);
  //   if (this.props.location !== prevProps.location) {
  //     this.callOwnProfile();
  //   }
  // }

  // callOwnProfile = () => {
  //   api.get(baseURL + "/manage-account/my-profile").then((res) => {
  //     if (res.data.result.isError === false) {
  //       if (res.data.result.statusCode === 210) {
  //         this.setState({ showPassError: true });
  //         localStorage.setItem("myProfile", JSON.stringify(this.state));
  //       }
  //       this.setState({ ownProfile: res.data.data }, () => {
  //         localStorage.setItem(
  //           "myProfile",
  //           JSON.stringify(this.state.ownProfile)
  //         );
  //         this.state.ownProfile !== undefined &&
  //           this.state.ownProfile.allowedFeatureList.map((v, i) => {
  //             //console.log("v", v);
  //             if (v.feature.name === "SignTask") {
  //               v.subFeatureList.map((u, k) => {
  //                 // console.log("u", u);
  //                 if (u.feature.protectedUrl === "/new-self-sign") {
  //                   this.setState({ showSelfSignBox: true });
  //                 } else if (u.feature.protectedUrl === "/new-sign") {
  //                   this.setState({ showSignBox: true });
  //                 } else {
  //                 }
  //               });
  //             }
  //           });

  //         if (this.state.ownProfile.credentialsExpired === true) {
  //           window.location = process.env.PUBLIC_URL + "/password-change";
  //         }
  //         //this.callgetUserListApi();
  //       });
  //     } else {
  //       if (res.data.result.statusCode === 510) {
  //         this.setState({ showPassError: true }, () => {
  //           localStorage.setItem("myProfile", JSON.stringify(this.state));
  //           window.location = process.env.PUBLIC_URL + "/password-change";
  //         });
  //       } else {
  //         console.log("Error for other than password");
  //         this.setState({ showPassError: true }, () => {
  //           localStorage.setItem("myProfile", JSON.stringify(this.state));
  //           window.location = process.env.PUBLIC_URL + "/password-change";
  //         });
  //       }
  //     }
  //   });
  // };
  callOwnProfile = () => {
    api.get(baseURL + "/manage-account/my-profile").then((res) => {
      if (res.data?.result?.isError === false) {
        const profile = res.data.data;

        if (profile.credentialsExpired) {
          this.setState({ showPassError: true });
          localStorage.setItem("myProfile", JSON.stringify(profile));
          if (window.location.pathname !== "/password-change") {
            window.location = process.env.PUBLIC_URL + "/password-change";
          }
        } else {
          this.setState({ ownProfile: profile });
          localStorage.setItem("myProfile", JSON.stringify(profile));
        }
      }
    });
  };
  render() {
    //const loggedIn = localStorage.getItem("loggedIn");
    const AppsRoute = (
      <Suspense fallback={<Spinner />}>
        <Switch>
          <Route exact path="/" component={Login2} />

          <Route path="/login2" component={Login} />
          <Route path="/login" component={Login2} />
          <Route path="/robilogin" component={RobiLogin} />
          <Route path="/forget-password" component={ForgetPassword} />
          <Route path="/change-password" component={ResetPassword} />
          <ProtectedRoute
            path="/imagecrop"
            component={ImageCrop}
            showPassError={this.state.showPassError}
          />
          <Route path="/dynaform" component={DynamicForm} />
          <ProtectedRoute
            exact
            path="/dashboard"
            component={Dashboard}
            showPassError={this.state.showPassError}
          />
          {/* <Route exact path="/package-management2" component={PackageManage} /> */}
          <Route exact path="/my-package" component={MyPackage} />
          <ProtectedRoute
            exact
            path="/admin/package-list"
            component={PackageList}
            showPassError={this.state.showPassError}
          />
          <ProtectedRoute
            exact
            path="/package-management"
            component={PackageManage2}
            showPassError={this.state.showPassError}
          />
          {/* <Route exact path="/package-list" component={PackageList} /> */}
          {/* <Route exact path="/admin/package-list" component={MyPackage} /> */}
          {/* <Route exact path="/admin/company-list" component={CompanyList} /> */}
          <ProtectedRoute
            exact
            path="/user-management"
            component={CompanyUserList}
            showPassError={this.state.showPassError}
          />
          <Route exact path="/company" component={NewCompany} />
          <ProtectedRoute
            exact
            path="/new-self-sign"
            component={NewSelfSign}
            showPassError={this.state.showPassError}
          />
          <ProtectedRoute
            exact
            path="/self-form-sign"
            component={StartFollow}
            showPassError={this.state.showPassError}
          />
          <ProtectedRoute
            exact
            path="/start-template-sign"
            component={StartTempSign}
            showPassError={this.state.showPassError}
          />
          <ProtectedRoute
            exact
            path="/new-form-sign"
            component={StartMulti}
            showPassError={this.state.showPassError}
          />
          <ProtectedRoute
            exact
            path="/storage-package-list"
            component={StoragePlanList}
            showPassError={this.state.showPassError}
          />
          <ProtectedRoute
            exact
            path="/new-storage-plan"
            component={NewStoragePlan}
            showPassError={this.state.showPassError}
          />
          <ProtectedRoute
            exact
            path="/package-distribute"
            component={PackageDistribute}
            showPassError={this.state.showPassError}
          />
          <ProtectedRoute
            exact
            path="/storage-management"
            component={StorageManagement}
            showPassError={this.state.showPassError}
          />
          <ProtectedRoute
            exact
            path="/my-storage"
            component={MyStorage}
            showPassError={this.state.showPassError}
          />
          <ProtectedRoute
            exact
            path="/purchase-history"
            component={PurchaseHistory}
            showPassError={this.state.showPassError}
          />
          <ProtectedRoute
            exact
            path="/pending-purchase"
            component={PendingPurchase}
            showPassError={this.state.showPassError}
          />
          {/* <ProtectedRoute
            exact
            path="/purchase-storage2"
            component={StorageShop1}
            showPassError={this.state.showPassError}
          /> */}
          <ProtectedRoute
            exact
            path="/availablestorage-package"
            component={StorageShop}
            showPassError={this.state.showPassError}
          />
          <ProtectedRoute
            exact
            path="/storage-balance-request"
            component={StorageRequest}
            showPassError={this.state.showPassError}
          />
          <ProtectedRoute
            exact
            path="/admin-registration"
            component={AdminRegistration}
            showPassError={this.state.showPassError}
          />
          <Route exact path="/register" component={Register} />
          <ProtectedRoute
            exact
            path="/new-sign"
            component={NewSign}
            showPassError={this.state.showPassError}
          />
          <ProtectedRoute
            path="/pending-sign-list"
            component={PendingForMe}
            showPassError={this.state.showPassError}
          />
          <ProtectedRoute
            path="/pending-others-sign-list"
            component={PendingForOther}
            showPassError={this.state.showPassError}
          />
          <ProtectedRoute
            path="/bulkstatusupdate"
            component={BulkStatusUpdate}
            showPassError={this.state.showPassError}
          />
          <ProtectedRoute
            path="/bulkcancel"
            component={BulkCancelStatus}
            showPassError={this.state.showPassError}
          />
          <ProtectedRoute
            exact
            path="/completed-sign-list"
            component={CompletedSign}
            showPassError={this.state.showPassError}
          />
          <ProtectedRoute
            exact
            path="/rejected-sign-list"
            component={RejectedSign}
          />
          <ProtectedRoute
            exact
            path="/my-documents"
            component={ArchiveSign}
            showPassError={this.state.showPassError}
          />
          <ProtectedRoute
            exact
            path="/my-signature"
            component={ManageSignature}
            showPassError={this.state.showPassError}
          />
          <ProtectedRoute
            exact
            path="/signing-active-list"
            component={ActiveFiles}
            showPassError={this.state.showPassError}
          />
          {/* <ProtectedRoute
            path="/signing/signing-request"
            component={SigningRequest}
          /> */}
          <ProtectedRoute
            exact
            path="/signing-start-sign"
            component={StartSign2}
            showPassError={this.state.showPassError}
          />
          <ProtectedRoute
            exact
            path="/view-pdf"
            component={ViewPdf}
            showPassError={this.state.showPassError}
          />
          <ProtectedRoute
            exact
            path="/activity-log"
            component={ActivityLog}
            showPassError={this.state.showPassError}
          />
          <ProtectedRoute
            exact
            path="/reports"
            component={Reports}
            showPassError={this.state.showPassError}
          />
          <ProtectedRoute
            exact
            path="/ekyc-info"
            component={EkycInfo}
            showPassError={this.state.showPassError}
          />
          <ProtectedRoute
            exact
            path="/users-list"
            component={UserList}
            showPassError={this.state.showPassError}
          />
          <ProtectedRoute
            exact
            path="/user"
            component={NewUser}
            showPassError={this.state.showPassError}
          />
          <ProtectedRoute
            path="/statusupdate"
            component={StatusUpdate}
            showPassError={this.state.showPassError}
          />
          <ProtectedRoute
            path="/pending"
            component={PendingRequest}
            showPassError={this.state.showPassError}
          />
          <ProtectedRoute
            path="/preview"
            component={PreviewDoc}
            showPassError={this.state.showPassError}
          />
          <ProtectedRoute
            path="/pdfprepare"
            component={PdfPrepare}
            showPassError={this.state.showPassError}
          />

          <ProtectedRoute
            path="/cancelled"
            component={Cancelled}
            showPassError={this.state.showPassError}
          />
          <ProtectedRoute
            path="/successful"
            component={Successfull}
            showPassError={this.state.showPassError}
          />
          <ProtectedRoute
            path="/failed"
            component={Failed}
            showPassError={this.state.showPassError}
          />

          <ProtectedRoute path="/my-profile" component={MyProfile} />
          <ProtectedRoute path="/password-change" component={ChangePassword} />

          <ProtectedRoute path="/user-pages-error-500" component={Error500} />
          <ProtectedRoute path="/user-pages-blank-page" component={BlankPage} />
          <Route path="/unauthorized" component={Unauthorized} />
          <Route component={Error404} />
          {/* <Redirect to="/" /> */}
        </Switch>
      </Suspense>
    );
    return <>{AppsRoute}</>;
  }
}

export default AppRoutes;
